export default __webpack_public_path__ + "static/media/Google.f5f8e511.svg";